// @ts-nocheck
import * as Types from '../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type MadTypesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type MadTypesQuery = { __typename?: 'Query', enumDetails: { __typename?: 'AllEnumDetails', materialAttributeDimensionType: Array<{ __typename?: 'MaterialAttributeDimensionTypeDetail', code: Types.MaterialAttributeDimensionType, name: string }> } };

export type MadTypeFragment = { __typename?: 'MaterialAttributeDimensionTypeDetail', code: Types.MaterialAttributeDimensionType, name: string };

export const MadTypeFragmentDoc = gql`
    fragment MadType on MaterialAttributeDimensionTypeDetail {
  code
  name
}
    `;
export const MadTypesDocument = gql`
    query MadTypes {
  enumDetails {
    materialAttributeDimensionType {
      ...MadType
    }
  }
}
    ${MadTypeFragmentDoc}`;

/**
 * __useMadTypesQuery__
 *
 * To run a query within a React component, call `useMadTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMadTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMadTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useMadTypesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MadTypesQuery, MadTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MadTypesQuery, MadTypesQueryVariables>(MadTypesDocument, options);
      }
export function useMadTypesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MadTypesQuery, MadTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MadTypesQuery, MadTypesQueryVariables>(MadTypesDocument, options);
        }
// @ts-ignore
export function useMadTypesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<MadTypesQuery, MadTypesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MadTypesQuery, MadTypesQueryVariables>;
export function useMadTypesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MadTypesQuery, MadTypesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MadTypesQuery | undefined, MadTypesQueryVariables>;
export function useMadTypesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MadTypesQuery, MadTypesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MadTypesQuery, MadTypesQueryVariables>(MadTypesDocument, options);
        }
export type MadTypesQueryHookResult = ReturnType<typeof useMadTypesQuery>;
export type MadTypesLazyQueryHookResult = ReturnType<typeof useMadTypesLazyQuery>;
export type MadTypesSuspenseQueryHookResult = ReturnType<typeof useMadTypesSuspenseQuery>;
export type MadTypesQueryResult = Apollo.QueryResult<MadTypesQuery, MadTypesQueryVariables>;